/* jshint esversion: 11 */

// Nur eine laufende Ziege je Browser-Speicher. Auf Android teilen sich die installierte
// App und die Chrome-Tabs denselben Speicher; zwei Instanzen hätten dieselbe Geräte-ID,
// teilten sich die an das Gerät zugestellten Schlüssel und die nur einmal gültigen
// Refresh-Tokens und blockierten sich gegenseitig beim Schlüsselspeicher. Eine Instanz
// im Hintergrund kann eingefroren sein und gibt dann nichts frei; die Sperre wird
// deshalb nie gestohlen, sondern nur abgewartet.

const LOCK_NAME = "ziege-app";

let release = null;

function request(options) {
    return new Promise((granted) => {
        navigator.locks.request(LOCK_NAME, options, (lock) => {
            if (!lock) {
                granted(false);
                return undefined;
            }
            return new Promise((releaseLock) => {
                release = releaseLock;
                granted(true);
            });
        });
    });
}

// Wartet, bis diese Seite die Sperre hat; ist sie anderswo belegt, meldet waiting()
// das einmal. Die Sperre gilt, bis releaseAppLock() oder das Ende der Seite.
export async function holdAppLock(waiting) {
    if (!navigator.locks || release) {
        return;
    }
    if (await request({ifAvailable: true})) {
        return;
    }
    waiting();
    await request({});
}

export function releaseAppLock() {
    release?.();
    release = null;
}
